import React, { Route, Routes, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import LoadingPage from '../pages/auth/LoadingPage';
import LoginPage from '../pages/auth/LoginPage';
import SuperLoginPage from '../pages/auth/SuperLoginPage';
import SignupPage from '../pages/auth/SignupPage';
import ForgotPasswordPage from '../pages/auth/ForgotPasswordPage';
import ResetPasswordPage from '../pages/auth/ResetPasswordPage';
import VerifyEmailPage from '../pages/auth/VerifyEmailPage';
import VerifyUserPage from '../pages/auth/VerifyUserPage';
import MainLayoutRouter from './MainLayoutRouter';
import CreateBookingPage from '../pages/booking/CreateBookingPage';
import PreviewPerks from '../pages/perks/PreviewPerks';
import AppLogout from '../components/AppLogout';

const MainRouter = () => {
  const { isAuthenticated, isSuper } = useSelector(state => ({
    isAuthenticated: state.auth.isAuthenticated,
    isSuper: state.auth.isSuper,
  }));

  return (
    <Routes>
      <Route path='login' element={isAuthenticated ? <Navigate to="/" /> : <LoginPage />} />
      <Route path='superadmin/secure' element={isAuthenticated ? <Navigate to="/" /> : <SuperLoginPage />} />
      <Route path='signup' element={isAuthenticated ? <Navigate to="/" /> : <SignupPage />} />
      <Route path='forgot-password' element={isAuthenticated ? <Navigate to="/" /> : <ForgotPasswordPage />} />
      <Route path='reset-password/:token' element={isAuthenticated ? <Navigate to="/" /> : <ResetPasswordPage />} />
      <Route path='verify-email' element={isAuthenticated ? <Navigate to="/" /> : <VerifyEmailPage />} />
      <Route path='/:username/book' element={<CreateBookingPage isPerk={false} />} />
      <Route path='/:username/book-perk' element={<CreateBookingPage isPerk={true} />} />
      <Route path='/users/verify/:token' element={<VerifyUserPage />} />
      <Route path='/:username/perks' element={<PreviewPerks />} />
      
      <Route
        path='*'
        element={isAuthenticated ?
          <AppLogout>
            <MainLayoutRouter isSuper={isSuper} />
          </AppLogout> :
          isAuthenticated != null ?
            <LoginPage /> :
            <LoadingPage />
        }
      />
    </Routes>
  );
}

export default MainRouter;
